export const defaultConsentActions = {
    loadDocuments: () => Promise.resolve(),
    addDocument: () => Promise.resolve(),
    updateDocument: () => Promise.resolve(),
    setActiveDocument: () => { },
    addElement: () => { },
    autoMapElements: () => { },
    updateElement: () => { },
    deleteElement: () => { },
    updateDocumentRoles: () => { },
    saveDocumentToStorage: () => Promise.resolve(),
    uploadConsentFile: () => Promise.resolve(),
    archiveTemplateVersion: () => Promise.resolve(),
    fetchDocumentPdf: () => Promise.resolve(),
    saveConsentTemplate: () => Promise.resolve(),
    publishConsentTemplate: () => Promise.resolve(),
};
